module.exports = __webpack_public_path__ + "static/media/N1_GLOSS.eadf6796.png";